// Autocomplete.js
import { useEffect, useRef, useState } from 'react';
import styles from './autocomplete.module.css';
import attentionIcon from 'assets/svg/attention-01.svg';

const Autocomplete = ({
  items,
  keyItem = 'id',
  valueItem = 'name',
  onChange,
  onSelect,
  selected,
  preSelectedItems = undefined,
  preSelectedTitle = 'Используется',
  placeholder = 'Введите название...',
  minValueForSearch = 3,
  disabled = false,
  renderOption = undefined,
  required = false,
  isFormValidate,
  errorMessage = undefined,
  hideErrorBlock = false,
}) => {
  const [filteredItems, setFilteredItems] = useState([]);
  const [selectedValue, setSelectedValue] = useState();
  const [inputValue, setInputValue] = useState('');
  const [visibleOptions, setVisibleOptions] = useState(false);
  const ref = useRef(null);
  const [position, setPosition] = useState({ top: 0, left: 0, width: 0 });

  useEffect(() => {
    if (!visibleOptions) return;

    const calculatePosition = () => {
      if (ref.current) {
        const rect = ref.current.getBoundingClientRect();
        setPosition({
          top: rect.bottom,
          left: rect.left,
          width: rect.width,
        });
      }
    };

    calculatePosition();

    window.addEventListener('scroll', calculatePosition, true);
    window.addEventListener('resize', calculatePosition);

    return () => {
      window.removeEventListener('scroll', calculatePosition, true);
      window.removeEventListener('resize', calculatePosition);
    };
  }, [visibleOptions]);

  useEffect(() => {
    if (selected) {
      setInputValue(selected[valueItem] ?? '');
    }
  }, [selected]);

  useEffect(() => {
    setFilteredItems(items);
  }, [items]);

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleChange = (event) => {
    const inputValue = event.target.value;
    setInputValue(inputValue);
    setFilteredItems(items);

    event.stopPropagation();
    if (event.target.value.length < minValueForSearch) {
      setFilteredItems([]);
      return;
    }
    onChange(inputValue);
  };

  const handleSelect = (value) => {
    setInputValue(renderElement(value));
    setVisibleOptions(false);
    setSelectedValue(value);
    // setFilteredItems([]);
    onSelect(value[keyItem], value);
  };

  const toggleVisibility = () => {
    setVisibleOptions((prev) => !prev);
  };

  const handleClickOutside = (event) => {
    if (ref.current && !ref.current.contains(event.target)) {
      setVisibleOptions(false);
    } else setVisibleOptions(true);
  };

  const renderElement = (value) => (renderOption ? renderOption(value) : value[valueItem]);

  return (
    <div ref={ref} className={styles['autocomplete-container']}>
      <input
        className={styles['autocomplete-input']}
        type="text"
        value={inputValue}
        onChange={handleChange}
        onBlur={() => {
          if (selectedValue) {
            setInputValue(renderElement(selectedValue));
          }
        }}
        onClick={() => {
          if (selectedValue) {
            setInputValue(selectedValue[keyItem]);
          }
          setVisibleOptions(true);
        }}
        placeholder={placeholder}
        disabled={disabled}
      />
      {visibleOptions && (
        <ul
          className={styles['autocomplete-suggestions']}
          style={{
            border: visibleOptions && filteredItems?.length ? '1px solid #ccc' : 'none',
            top: `${position.top}px`,
            left: `${position.left}px`,
            width: `${position.width}px`,
          }}
        >
          {preSelectedItems && (
            <>
              <li className={styles['suggestion-title']}>{preSelectedTitle}</li>
              {preSelectedItems?.map((item, index) => (
                <li
                  key={index}
                  className={styles['autocomplete-suggestion']}
                  onClick={() => handleSelect(item)}
                >
                  {renderElement(item)}
                </li>
              ))}
            </>
          )}
          <li className={styles['suggestion-title']}>Результаты поиска</li>
          {filteredItems?.map((item, index) => (
            <li
              key={index}
              className={styles['autocomplete-suggestion']}
              onClick={() => handleSelect(item)}
            >
              {renderElement(item)}
            </li>
          ))}
        </ul>
      )}

      {!hideErrorBlock && (
        <div className={styles.dataErrorBlock}>
          {required && !selectedValue && isFormValidate && (
            <>
              <img src={attentionIcon} alt={'attention'} />
              <div className={styles.dataError}>
                {errorMessage?.message || 'Поле обязательно для заполнения'}
              </div>
            </>
          )}
        </div>
      )}
    </div>
  );
};

export default Autocomplete;
